var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.buttons)?_c('section',{staticClass:"vdp__actions my-6 d-print-none"},_vm._l((_vm.buttons),function(button,index){return _c(button,_vm._b({key:("button-" + index),tag:"component"},'component',_vm.$props,false))}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }